import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Global safeguard for any cached production tracker chunks
if (typeof window !== 'undefined' && typeof window.hasMixedUnits === 'undefined') {
  window.hasMixedUnits = false;
}

import App from './App';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';
import { initializeCapacitor } from './utils/capacitorInit';
import { Capacitor } from '@capacitor/core';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize Capacitor for native Android app
initializeCapacitor().catch((error) => {
  console.error('Failed to initialize Capacitor:', error);
});

// ALWAYS unregister any existing service workers and purge stale cache storage
// on BOTH native and web platforms so old builds are never served from cache.
serviceWorkerRegistration.unregister();
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => {
      reg.unregister();
      console.log('[SW] Unregistered existing service worker:', reg.scope);
    });
  });
}
if ('caches' in window) {
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      caches.delete(cacheName);
      console.log('[SW] Cleared cache:', cacheName);
    });
  });
}








